import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MapConfiguration } from 'shared-lib';
import { GoogleMap } from '@angular/google-maps';

@Component({
  selector: 'app-map-configuration',
  standalone: false,
  templateUrl: './map-configuration.component.html',
  styleUrl: './map-configuration.component.scss'
})
export class MapConfigurationComponent implements  OnDestroy {
  @ViewChild('closeMapConfigurationModal') closeMapConfigurationModal: ElementRef;
  @ViewChild('streetviewSmall') streetviewSmall: any;
  @ViewChild('map', { static: false }) map!: GoogleMap;
  
  @Input() longitude: any;
  @Input() latitude: any;
  @Input() zoom: any;

  @Output() mapConfigurationSaved = new EventEmitter<MapConfiguration>();
  pegmanOption: Element | null;
  isStreetViewLayerVisible: boolean = false;
  isStreetViewVisible: boolean = false;
  streetViewLayer: google.maps.StreetViewCoverageLayer;
  panorama!: google.maps.StreetViewPanorama;
  public agmMap: google.maps.Map | null = null;

  mapConfiguration: MapConfiguration = new MapConfiguration();

  @Input() set setMapVisibility(isMapVisible: boolean) {
    this.removeEventListeners();
    this.setPegmanClickListener();
    this.showSmallStreetView(this.latitude, this.longitude);
  }
  constructor() { }

  ngOnDestroy(): void {
    this.removeEventListeners();
  }

  mapReady(map: any) {
    this.agmMap = map;
    this.streetViewLayer = new google.maps.StreetViewCoverageLayer();
  }

  /**
   * It will show a street view container in the bottom right of the map
   * @param lat Location latitude
   * @param lng Location longitude
   */
    showSmallStreetView(lat: number, lng: number) {
        this.isStreetViewVisible = true;
        if (!this.streetviewSmall) {
        return;
        }

        let streetViewPosition: google.maps.LatLngLiteral = { lat: lat, lng: lng };

        try {
        this.panorama = new google.maps.StreetViewPanorama(this.streetviewSmall.nativeElement, {
            position: streetViewPosition,
            scrollwheel: true,
            zoom: 1,
            fullscreenControl: true,
            showRoadLabels: true,
            visible: true,
            addressControl: false,
            panControl: true
        });

        this.agmMap?.setStreetView(this.panorama);
        } catch (error) {
            console.error('Error initializing Street View Panorama:', error);
        }
    }
    
    /**
     * It will listen for click events on the "pegman" option on the map and
     * display/hide street view layer (blue line showing where street view is available)
     * @param event An event which takes place in the DOM
     */
    streetViewToggleListener: EventListener = (event: Event) => {
        this.isStreetViewLayerVisible = !this.isStreetViewLayerVisible;
    
        if (this.isStreetViewLayerVisible) {
            this.streetViewLayer.setMap(this.agmMap);
        } else {
            this.streetViewLayer.setMap(null);
        }
    }

    removeEventListeners() {
      if (this.pegmanOption) {
          this.pegmanOption?.removeEventListener('click', this.streetViewToggleListener);
      }
    }

    setPegmanClickListener() {
        try {
          setTimeout(() => {
            this.pegmanOption = window.document.querySelector('button.gm-svpc');
    
            if (this.pegmanOption) {
              this.pegmanOption.addEventListener('click', this.streetViewToggleListener);
            }
          }, 1200);
        } catch (error) {
          console.error('Error setting Pegman click listener:', error);
        }
      }

  saveMapConfiguration() {
    if (this.map) {
      const center = this.map.getCenter();
      const zoom = this.map.getZoom();

      if (center) {
        const lat = center.lat();
        const lng = center.lng();

        this.mapConfiguration.latitude = lat;
        this.mapConfiguration.longitude = lng;
        this.mapConfiguration.zoom = zoom;

        this.mapConfigurationSaved.emit(this.mapConfiguration);
        this.closeMapConfigModal();
      }
    }
  }

  closeMapConfigModal() {
    if (this.closeMapConfigurationModal) {
      this.closeMapConfigurationModal.nativeElement.click();
    }
  }
}
